import React from 'react'
import { Bar } from 'react-chartjs-2'
import Style from './BarGraph.module.css'
const BarGraph = ({repoarts}) => {
    let labelHolder=[]
    let dataHolder=[]
    repoarts.forEach(element => {
        labelHolder.push(element.date)
        dataHolder.push(element.count)
    });
    
    
    return (
        <div className={Style.BarHolder}>
            <Bar
                data={{
                    labels: labelHolder,
                    datasets: [{
                        label:' تعداد فروش هر روز هفته',
                        data: dataHolder,
                        backgroundColor: [
                            '#C20C64'
                        ],
                        borderRadius:3,
                    }]
                }}
                
                width={'100%'}
                height={250}
                options={{ maintainAspectRatio: false,
                    
                    scales: {
                        
                    x: {
                        beginAtZero: true,
                        grid:{
                            display:false
                        },
                        ticks: {
                            font: {
                                size:15,
                                family: 'iran-sans-num',
                            }
                        }
                        
                    },
                    y: {
                        beginAtZero: true,
                        grid:{
                            display:false
                        },
                        ticks: {
                            beginAtZero:true,
                            stepSize: 1,
                            font: {
                                size:12,
                                family: 'iran-sans-num',
                            },
                          

                        }
                        
                    },
                    
                    
                },
                plugins:{
                    legend:{
                        labels:{
                            boxWidth:0,
                            font: {
                                family: 'iran-sans-num' ,
                                
                            }
                        },
                        
                    },
                      
                }
                 
                }}
            />
        </div>
    )
}

export default BarGraph
